// extracted by mini-css-extract-plugin
export default {"root":"matches_named_resources_selector-module___root___e79efb77"};